import { LiaRupeeSignSolid } from "react-icons/lia";
import { useState, useEffect } from "react";
import {
  FaCheckCircle,
  FaShippingFast,
  FaBoxOpen,
  FaGem,
  FaGlobe,FaChevronUp, FaChevronDown
} from "react-icons/fa";
import {
  Button,
  HeadingTitle,
  Loader,
  Ratings,
  SubHeadingTitle,
} from "../../../components/shared/index";
import styles from "./productdetails.module.css";
import toast from "react-hot-toast";
import authService from "../../../services/authService";
import { useNavigate } from "react-router-dom";
const ProductInfo = ({
  productData,
  addToCart,
  isPending,
  isCartPending,
  isError,
  error,
}) => {
  const isLoggedIn = authService.isLoggedIn();
  const navigate = useNavigate();
const [quantity, setQuantity] = useState(1);
const addItemToCart = async () => {
  if (!isLoggedIn) {
    toast.error("⚠️ Please login first");
    return false;
  }
  if (productData?.qty < 1) {
    toast.error("❌ Product is out of stock");
    return false;
  }
  try {
    await addToCart({
      product_id: productData?.id,
      quantity:  quantity,
    });
    toast.success("Item added to cart");
    return true;
  } catch {
    toast.error("Something went wrong");
    return false;
  }
};
  const handleAddToCart = async () => {
    await addItemToCart();
  };
const handleBuyNow = () => {
  // If user is not logged in, go directly to login page
  if (!isLoggedIn) {
    navigate("/login");
    return;
  }

  // Check product stock
  if (productData?.qty < 1) {
    toast.error("❌ Product is out of stock");
    return;
  }

  // Logged-in user can continue to checkout
  navigate("/checkout/payment", {
    state: {
      buyNow: true,
      product: productData,
      quantity,
    },
  });
};

useEffect(() => {
  setQuantity(1);
}, [productData?.id]);
const increaseQty = () => {
  if (quantity < productData?.qty) {
    setQuantity(prev => prev + 1);
  }
};
const decreaseQty = () => {
  if (quantity > 1) {
    setQuantity(prev => prev - 1);
  }
};
  return (
    <div className={styles.rightSection}>
      {isPending ? (
        <div className={styles.productInfoLoader}>
          <Loader title="Loading product details..." />
        </div>
      ) : isError ? (
        <SubHeadingTitle
          style={styles.errorMessage}
          subTitle={error?.message || "Failed to load product details"}
        />
      ) : (
        <>
         <HeadingTitle
  text={productData?.name || ""}
  style={styles.heading}
/>
          <Ratings rating={productData?.rating || 0} />
          <div className={styles.metaInfo}>
<div className={styles.priceWrapper}>
  {/* Offer Price or Normal Price */}
  {productData?.offer_price && productData.offer_price > 0 ? (
    <>
      <h3 className={styles.offerPrice}>
        <LiaRupeeSignSolid className={styles.priceIcon} size={24} />
        {productData.offer_price.toLocaleString()} /-
      </h3>

      <h4 className={styles.originalPrice}>
        <LiaRupeeSignSolid className={styles.priceIcon} size={18} />
        {productData.price.toLocaleString()}
      </h4>

      <span className={styles.discountText}>
        {Math.round(
          ((productData.price - productData.offer_price) / productData.price) *
            100
        )}
        % off
      </span>
    </>   
  ) : (
    <h3 className={styles.offerPrice}>
      <LiaRupeeSignSolid className={styles.priceIcon} size={24} />
      {productData.price.toLocaleString()} /-
    </h3>
  )}
</div>  
             <SubHeadingTitle 
    style={styles.sku}
    subTitle={
      <>
        <span>SKU : </span>
        <span>{productData?.sku || "N/A"}</span>
      </>
    }
  />
          </div>
{productData?.qty > 0 && (
  <div className={styles.qtyRow}>
    <span className={styles.qtyTitle}>Quantity :</span>
    <div className={styles.qtyBox}>
      <span className={styles.qtyNumber}>{quantity}</span> 
      <div className={styles.qtyArrows}>
        <button
          type="button"
          onClick={increaseQty}
          disabled={quantity === productData?.qty}
        >
          <FaChevronUp size={12} />
        </button>
        <button
          type="button"
          onClick={decreaseQty}
          disabled={quantity === 1}
        >
          <FaChevronDown size={12} />
        </button>
      </div>
    </div>
  </div>
)}
          <SubHeadingTitle
            subTitle={
              <>
                <span>Availability: </span>
                <span
                  className={
                    productData?.qty > 0
                      ? styles.inStock
                      : styles.outOfStock
                  }
                >
                  {productData?.qty > 0 ? "In Stock" : "Out of Stock"}
                </span>
              </>
            }
          />
          <div className={styles.btnGroup}>
            <Button
              type="button"
              title={isCartPending ? "Adding to Cart..." : "Add To Cart"}
              style={styles.cartBtn}
              disabled={productData?.qty < 1 || isCartPending}
              onHandler={handleAddToCart}
            />
            <Button
              type="button"
              title="Buy Now"
              style={styles.buyBtn}
              disabled={productData?.qty < 1 || isCartPending}
              onHandler={handleBuyNow}
            />
          </div>
          <ul className={styles.featureList}>
            <li>
              <FaCheckCircle size={22} color="black" /> COD, Easy Returns & Quick Exchanges
            </li>
            <li>
              <FaShippingFast size={22} color="black" /> Express 24-Hour Delivery (Charges Apply)
            </li>
            <li>
              <FaBoxOpen size={22} color="black"/> Free Shipping on Prepaid Orders Above ₹1000
            </li>
            <li>
              <FaGem size={22} color="black"/> Premium Quality Stones, Plating & Handwork
            </li>
            <li>
              <FaGlobe size={22} color="black"/> Trusted by 1.2M+ Customers Worldwide
            </li>
          </ul>
        </>
      )}
    </div>
  );
};
export default ProductInfo;